<h1 mat-dialog-title>
    Inquire
</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <div class="d-flex flex-column">
            <div class="d-flex flex-column mt-1">
                <mat-label>Email: <span class="required-input">*</span></mat-label>
                <mat-form-field appearance="fill">
                    <input matInput class="email-input" formControlName="email" placeholder="Email..">
                    <mat-error *ngIf="!this.form.get('email')?.value">
                        Email is required
                    </mat-error>
                    <mat-error *ngIf="!this.form.get('email')?.valid && this.form.get('email')?.value">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>
            </div>
            <mat-label>My Question is About: <span class="required-input">*</span></mat-label>
            <mat-form-field appearance="fill">
                <mat-select formControlName="questionAbout">
                    <mat-option value="Draft claim">Draft Claim</mat-option>
                    <mat-option value="Submitted (in process) claim">Submitted (In Process) Claim</mat-option>
                    <mat-option value="Payment amount">Payment Amount</mat-option>
                    <mat-option value="I have not received the payment">I Have Not Received the Payment</mat-option>
                    <mat-option value="Other question or comment">Other Question or Comment</mat-option>
                </mat-select>
                <mat-error *ngIf="!this.form.get('questionAbout')?.value">
                    Question Type is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="d-flex flex-column mt-1">
            <mat-label>Please ask us your question or tell us your comment: <span class="required-input">*</span></mat-label>
            <mat-form-field appearance="fill">
                <textarea class="comment-input" rows="10" matInput formControlName="comment" placeholder="Comment..." required></textarea>
                <mat-error *ngIf="!this.form.get('comment')?.value">
                    Comment or Question is required
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onCancelClick()">
        Cancel
    </button>
    <button mat-raised-button (click)="onSendClick()" [disabled]="!isSendEnabled()">
        Send
    </button>
</div>